






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { FotowandCanvasManager } from '@/lib/CanvasManager/FotowandCanvasManager';

@Component({})
export default class Canvas extends Vue {
  @State((state) => state.canvas.manager) canvasManager!: FotowandCanvasManager;
  @State((state) => state.onboarding.active) onboardingActive!: boolean;
  @State((state) => state.onboarding.step) onboardingStep!: number;
  @State(
    (state) => !!state.design.background || state.design.design.layers.length !== 0 || state.design.images.length !== 0,
  )
  hasContent!: boolean;
  @State((state) => state) state;
  @State((state) => state.design.background) background!: boolean;
  @Prop([Boolean, String]) loading: boolean;
  @Prop(String) height: string;
  canvasReady = false;

  cleared = true;
  async mounted() {
    await this.canvasManager.initialize(this.$refs.canvas as HTMLCanvasElement);
    this.$root.$emit('canvas:ready');

    window.addEventListener('wheel', () => {
      cancelAnimationFrame(this.animationFrame);
    });
    window.addEventListener('touchstart', () => {
      cancelAnimationFrame(this.animationFrame);
    });
    window.addEventListener('selection:cleared', () => {
      this.cleared = true;
    });
    window.addEventListener('object:selected', () => {
      this.cleared = false;
    });
    window.addEventListener('background:selected', () => {
      this.cleared = false;
    });

    this.canvasReady = true;
  }

  beforeDestroy() {
    window.removeEventListener('wheel', () => {
      cancelAnimationFrame(this.animationFrame);
    });
    window.removeEventListener('touchstart', () => {
      cancelAnimationFrame(this.animationFrame);
    });
    window.removeEventListener('selection:cleared', () => {
      this.cleared = true;
    });
    window.removeEventListener('object:selected', () => {
      this.cleared = false;
    });
    window.removeEventListener('background:selected', () => {
      this.cleared = false;
    });
  }

  animating = false;
  touchMoveCanvas(e) {
    // stop if the touchstart was not run (because we are transforming an object for example).
    if (!this.useCanvas || !this.pressed) {
      return;
    }

    // prevent default behaviour
    e.preventDefault();

    // debounce with animationFrame
    if (!this.animating) {
      requestAnimationFrame(() => {
        // scroll the page if more then 1px was moved
        const y = e.touches[0].clientY;
        const delta = this.touchYStart - y;
        if (delta > 1 || delta < -1) {
          this.touchYStart = y;
          this.scroll(this.offset + delta);
        }

        this.animating = false;
      });

      this.animating = true;
    }
  }

  useCanvas = false;
  touchYStart = 0;
  velocity = 0;
  amplitude = 0;
  pressed = false;
  timer = null;
  ticker = null;
  offset = 0;
  frame = null;
  animationFrame = null;
  touchStartCanvas(e) {
    // set velocity and amplitude to 0;
    this.velocity = 0;
    this.amplitude = 0;

    // check if canvas is cleared (no selections)
    const wrapper = this.$refs.canvasWrapper as HTMLElement;
    if (!this.cleared) {
      this.useCanvas = false;
      return;
    }

    if (!wrapper.contains(e.target)) {
      this.useCanvas = false;
      return;
    }

    // prevent default behaviour
    e.preventDefault();

    // set current scroll offset
    this.offset = window.scrollY;
    // set the useCanvas and pressed, this is used to block the touchmove
    this.useCanvas = true;
    this.pressed = true;
    // frame is used to get the px moved between a certain time
    this.frame = this.offset;
    // reset the timer
    this.timer = Date.now();

    // cancel current scroll velocity
    cancelAnimationFrame(this.animationFrame);
    // cancel the previous track ticker
    clearInterval(this.ticker);
    // initiate a new tracker
    this.ticker = setInterval(this.track, 100);
    // set the initial touchY value
    this.touchYStart = e.touches[0].clientY;
  }

  track() {
    // calculate the velocity distance based on moved pixels and time pased.
    // https://ariya.io/2013/11/javascript-kinetic-scrolling-part-2
    const now = Date.now();
    const elapsed = now - this.timer;
    const delta = this.offset - this.frame;
    this.frame = this.offset;

    const v = (1000 * delta) / (1 + elapsed);
    this.velocity = 0.8 * v + 0.2 * this.velocity;
  }

  target = null;
  touchEndCanvas(e) {
    // prevent default behaviour
    e.preventDefault();

    // allow the canvas events to be triggered again
    this.useCanvas = true;
    this.pressed = false;

    // clear the tracker that was initiated during touchstart
    clearInterval(this.ticker);

    // calculate the actual extra pixels that need to be scrolled
    // https://ariya.io/2013/11/javascript-kinetic-scrolling-part-2
    if (this.velocity > 10 || this.velocity < -10) {
      this.amplitude = 0.8 * this.velocity;
      this.target = Math.round(this.offset + this.amplitude);
      this.timer = Date.now();
      this.animationFrame = requestAnimationFrame(this.autoScroll);
    }
  }

  autoScroll() {
    // keep scrolling as long as the time didnt ellapse
    // https://ariya.io/2013/11/javascript-kinetic-scrolling-part-2
    if (this.amplitude) {
      // deceleration rate, 325 is closest to native
      const timeConstant = 325;
      const elapsed = Date.now() - this.timer;
      const delta = -this.amplitude * Math.exp(-elapsed / timeConstant);
      if (delta > 0.5 || delta < -0.5) {
        this.scroll(this.target + delta);
        this.animationFrame = requestAnimationFrame(this.autoScroll);
      } else {
        this.scroll(this.target);
      }
    }
  }

  min = 0;
  max = window.innerHeight;
  body = document.querySelector('body');
  html = document.querySelector('html');
  scroll(y) {
    // check if we are at the start of end of page and set the correct offset
    this.offset = y > this.max ? this.max : y < this.min ? this.min : y;
    const scrollY = window.scrollY;

    // reflect the offset to the scrollTop
    this.html.scrollTop = this.offset;

    // in case browser doesn't scroll on html, but on body.
    if (window.scrollY === scrollY) {
      this.body.scrollTop = this.offset;
    }
  }
}
